import { CommonModule, NgFor, NgIf } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  ReactiveFormsModule,
  FormsModule,
  FormControl,
  Validators,
  FormGroup,
  FormBuilder,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import {
  MatSelect,
  MatSelectChange,
  MatSelectModule,
} from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSort, MatSortModule } from "@angular/material/sort";
import {
  MatTableModule,
  MatRowDef,
  MatTableDataSource,
} from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CompanyService } from "../../configuration/company/company.service.service";
import { DivisionService } from "../../configuration/division/division.service.service";
import { MaterialGroupService } from "../material-group/material-group.service";
import {
  CompanyAttributes,
  MaterialTypeAttributes,
  ShortSubApplicationsAttributes,
  UserFieldConfigAttributes,
} from "@albatrosdeveloper/ave-models-package";
import DivisionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/division/division.entity";
import MaterialGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-group/material-group.entity";
import MaterialAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/material.entity";
import MaterialBrandAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-brand/material-brand.entity";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ICreateMaterial } from "./interfaces/create-material.interface";
import { IUpdateMaterial } from "./interfaces/update-material.interface";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
  NgSelectModule,
} from "@ng-select/ng-select";
import { MaterialBrandService } from "../material-brand/material-brand.service";
import { MaterialService } from "./material.service";
import { UnitMeasureService } from "../../master/unit-of-measurement/unit-of-measurement.service";
import UnitMeasurementsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/unit-measurements/unit-measurements.entity";
import AlternalUnitMeasurementAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity";
import { ICreateUnitMeasure } from "./interfaces/create-unit-measure.interface";
import { MaterialUnitMeasureService } from "./material-unit-alternate.service";
import { ICreateOrder } from "./interfaces/create-order-delivery.interface";
import orderDeliveryWindowsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-delivery-windows/order-delivery-windows.entity";
import { OrderDeliveryService } from "./material-order-delivery.service";
import { MatTabsModule } from "@angular/material/tabs";
import { ICreateTax } from "./interfaces/create-tax.interface";
import { ICreateDimension } from "./interfaces/create-material-dimension";
import { MaterialTaxService } from "./material-tax/material-tax.service";
import { MaterialDimensionService } from "./material-dimension/material-dimension.service";
import { MonedaPipe } from "app/pipes/moneda.pipe";
import { AddMaterialUnit } from "./material-unit-modal/material-alternate-unit.component";
import { AddBusinessPartnerOrderComponent } from "../../business-partners/business-partner/business-partner-order-modal/business-partner-order.component";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ReplaySubject } from "rxjs/internal/ReplaySubject";
import { takeUntil } from "rxjs/internal/operators/takeUntil";
import {
  debounceTime,
  distinctUntilChanged,
  Subject,
  Subscription,
  switchMap,
  skip,
  take,
  firstValueFrom,
} from "rxjs";
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { MaterialTypeService } from "../material-type/material-type.service";
import { MaterialDistributionChainComponent } from "../distribution-chain-modal/distribution-chain.component";
import { MaterialDistributionService } from "../distribution-chain-modal/distribution-chain.component.service";
import { DeleteConfirmationComponent } from "../../business-partners/business-partner/delete-modal/delete-modal.component";
import RequirementAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/requirements/requirements.entity";
import { RequirementService } from "../../master/requirement/requirement.service";
import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
} from "@angular/cdk/drag-drop";
import clonedeep from "lodash.clonedeep";
import { ListImagesComponent } from "./list-images/list-images.component";
import { MaterialListService } from "../material-list/material-list.service";
import MaterialListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-list/material-list.entity";
import { debounce } from "lodash";
import { IPaginationResult } from "app/common/interfaces";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportDialogComponent } from "app/layout/export-overlay/dialog/export-dialog.component";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { MaterialExport } from "./exports/material.export";
import { MATERIAL_EXPORT_TITLE } from "./exports/material.constants";
import { OrdersCreationService } from "../../sales/order-generate/order-generate.service";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { MaterialsManagementFiltersComponent } from "../../filters/materials-management-filters/materials-management-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";
import {
  MaterialWarehouseAssignmentComponent,
  IWarehouseAssignmentData,
} from "./material-warehouse-assignment/material-warehouse-assignment.component";
import { MaterialWarehouseManagementComponent } from "./material-warehouse-management/material-warehouse-management.component";
import { ToggleOptionComponent } from "app/shared/components/form-ui/toggle-option/toggle-option.component";
import { UserFieldEntityTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/user-field-entity-type.enum";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";
import { CompanyFieldCatalogService } from "../../configuration/company/company-form-config/company-form-config.service";
import { UserFieldsConfigurationComponent } from "../../configuration/company/user-fields-configuration/user-fields-configuration.component";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";


@Component({
  selector: "app-material",
  templateUrl: "./material.component.html",
  styleUrl: "./material.component.scss",
  standalone: true,
  imports: [
    MonedaPipe,
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgxMatSelectSearchModule,
    NgFor,
    NgIf,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    DragDropModule,
    FilterComponent,
    StatusFiltersComponent,
    MaterialsManagementFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective,
    FormSectionComponent,
    MaterialWarehouseAssignmentComponent,
    MaterialWarehouseManagementComponent,
    ToggleOptionComponent,
    UserFieldsConfigurationComponent,
    DecimalFormatPipe,
    CompanyCurrencyPipe
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    MaterialExport,
  ],
})
export class MaterialComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  projectName = environment.projectName;
  private isInitialized = false;
  loadSetPosition = false;
  isEditSort = false;

  displayedColumns: string[] = [
    "code",
    "price",
    "costPrice",
    "company",
    "inventory",
    "statusId",
    "actions",
  ];
  displayedColumnsUMP: string[] = [
    "info",
    "quantity",
    "baseUnitofMeasure",
    "equivalentQuantity",
    "unitOfMeasure",
    // "conversionFactor",
    "barcode",
    "actions",
  ];
  displayedColumnsOrder: string[] = [
    "days",
    "hourStart",
    "hourEnd",
    "numberOfHoursToDelivery",
    "status",
    "actions",
  ];

  displayedColumnsMR: string[] = ["code", "name", "actions"];
  displayedColumnsChain: string[] = ["name", "channel", "statusId", "actions"];
  currentCreateMaterial: ICreateMaterial = this.initializeCreateMaterial();
  currentUpdateMaterial: MaterialAttributes | undefined;
  currentUpdateMaterialWarehouseIds: string[] = [];
  currentUpdateUnit: AlternalUnitMeasurementAttributes | undefined;
  currentCreateUnit: ICreateUnitMeasure = this.initializeCreateUnit();
  currentCreateTax: ICreateTax = this.initializeCreateTax();
  currentCreateDimension: ICreateDimension = this.initializeCreateDimension();
  currentDelivery: ICreateOrder = this.initializeCreateOrder();
  private searchSubject = new Subject<string>();
  daysList: { day: string; value: number }[] = [
    { day: "Lunes", value: 1 },
    { day: "Martes", value: 2 },
    { day: "Miércoles", value: 3 },
    { day: "Jueves", value: 4 },
    { day: "Viernes", value: 5 },
    { day: "Sábado", value: 6 },
    { day: "Domingo", value: 7 },
  ];
  companyList: CompanyAttributes[] = [];
  divisionList: DivisionAttributes[] = [];
  materialGroupList: MaterialGroupAttributes[] = [];
  requirementList: RequirementAttributes[] = [];
  applicationList: any[] = [];
  //arbol
  isProjectTree: boolean = environment.projectName == "CORTIJO" ? false : true;
  listCategories: any[] = [];
  listFilterCategories: any[] = [];
  searchMaterialGroup = "";
  materialGroupFilterList: any[] = [];
  categoryPrincipal: any = {
    code: "0",
    name: "Principal",
    fatherCode: "0",
    hasSubcategories: true,
    level: 0,
    expandable: true,
  };

  materialRelatedList: MaterialAttributes[] = [];
  materialBrandList: MaterialBrandAttributes[] = [];
  materialTypeList: MaterialTypeAttributes[] = [];
  baseUnitOfMeasuresList: UnitMeasurementsAttributes[] = [];
  distributionUnitOfMeasureList: UnitMeasurementsAttributes[] = [];
  materialListList: MaterialListAttributes[] = [];
  listFilterMaterialList: MaterialListAttributes[] = [];
  searchMaterialList = "";
  createForm: FormGroup;

  classificationList: { name: string; value: string }[] = [
    { name: "LANZAMIENTOS", value: "AN" },
    { name: "A", value: "A" },
    { name: "B", value: "B" },
    { name: "C", value: "C" },
    { name: "DESCONTINUADOS", value: "D" },
  ];

  orderWithoutStockList: { name: string; value: string | boolean }[] = [
    { name: "RESPETA CLASE DE DOCUMENTO", value: "NULL" },
    { name: "SI", value: true },
    { name: "NO", value: false },
  ];

  /** control for the selected material for multi-selection */
  public materialMultiCtrl: FormControl<MaterialAttributes[]> = new FormControl<
    MaterialAttributes[]
  >([]);

  /** control for the MatSelect filter keyword multi-selection */
  public materialMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of material filtered by search keyword */
  public filteredMaterials: ReplaySubject<MaterialAttributes[]> =
    new ReplaySubject<MaterialAttributes[]>(1);

  /** local copy of filtered material to help set the toggle all checkbox state */
  protected filteredMaterialCache: MaterialAttributes[] = [];

  /** control for the selected group for multi-selection */
  public groupMultiCtrl: FormControl<MaterialGroupAttributes[]> =
    new FormControl<MaterialGroupAttributes[]>([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public groupMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of group filtered by search keyword */
  public filteredGroup: ReplaySubject<MaterialGroupAttributes[]> =
    new ReplaySubject<MaterialGroupAttributes[]>(1);

  /** local copy of filtered group  to help set the toggle all checkbox state */
  protected filteredGroupCache: MaterialGroupAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateGroup = false;
  isCheckedGroup = false;

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  public subMultiCtrl = new FormControl([]);

  selectedCompanyIds: string[] = [];
  selectedDivisionIds: string[] = [];
  selectedMaterialGroupIds: string[] = [];
  selectedMaterialBrandIds: string[] = [];
  selectedBaseUnitOfMeasuresIds: string[] = [];
  dataSource: MaterialAttributes[] = [];
  materialPackagedList: any[] = [
    { value: 0, name: "No es material de embalaje" },
    { value: 1, name: "Permite venta" },
    { value: 2, name: "No permite venta" },
  ];
  UMP: AlternalUnitMeasurementAttributes[] = [];
  searchQuery = "";
  searchText = "";
  totalItems = 0;
  pageSize = 50;
  pageIndex: number = 1;
  totalItemsUnit = 0;
  pageSizeUnit = 3;
  pageIndexUnit = 0;
  isEditing: boolean = false;
  isEditingTax: boolean = false;
  isEditingDimension: boolean = false;
  isOrderEditing: boolean = false;
  showAddUnitForm: boolean = false;
  showAddOrderForm: boolean = false;

  dataSourceItem = new MatTableDataSource<MaterialAttributes>([]);
  filtereddataSourceItem = new MatTableDataSource<MaterialAttributes>([]);

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("addModalUnit") addModalUnit!: TemplateRef<any>;
  @ViewChild("deliveryModal") deliveryModal!: TemplateRef<any>;
  @ViewChild("deleteModalUnit") deleteModalUnit!: TemplateRef<any>;
  @ViewChild("deleteModalOrder") deleteModalOrder!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("multiSelect", { static: true }) multiSelect!: MatSelect;

  protected _onDestroy = new Subject<void>();

  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;
  selectedStatuses: number[] = [];
  selectedCreateTabIndex: number = 0;
  isWarehouseFormValid: boolean = true;

  // Propiedades para warehouse assignment en modal de editar
  selectedWarehousesEdit: string[] = [];
  availableInAllWarehousesEdit: boolean = false;
  isWarehouseEditFormValid: boolean = true;

  loadFiltersData = false;
  private companiesLoaded = false;
  private divisionsLoaded = false;
  private materialGroupsLoaded = false;
  private materialBrandsLoaded = false;
  private baseUnitsLoaded = false;
  private dataLoadedForCreateModal = false;
  private dataLoadedForEditModal = false;
  public ERPActive: boolean = false;
  public numberOfDecimals: number;

  fieldsMasterData: UserFieldConfigAttributes[] = [];
  fieldsMasterDataStatus: StatusEnum;

  constructor(
    private materialService: MaterialService,
    private unitService: MaterialUnitMeasureService,
    private taxService: MaterialTaxService,
    private dimensionService: MaterialDimensionService,
    private orderService: OrderDeliveryService,
    private companyService: CompanyService,
    private divisionService: DivisionService,
    private materialGroupService: MaterialGroupService,
    private materialBrandService: MaterialBrandService,
    private materialTypeService: MaterialTypeService,
    private baseunitService: UnitMeasureService,
    private readonly requirementService: RequirementService,
    private readonly materialDistributionService: MaterialDistributionService,
    private readonly materialListService: MaterialListService,
    private readonly ordersCreationService: OrdersCreationService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private materialExport: MaterialExport,
    private fb: FormBuilder,
    private companyFieldCatalogService: CompanyFieldCatalogService
  ) {
    this.form = this.fb.group({
      companyId: [],
      divisionId: [],
      materialGroupId: [],
      materialBrandId: [],
    });
    this.createForm = new FormGroup({
      name: this.groupMultiCtrl,
    });
  }

  ngAfterViewInit(): void {
    this.fetchCompanies();
    //setup inicial
    this.setupPaginationAndSorting();
    //marcar como inicializado
    this.isInitialized = true;
    // búsqueda y filtros
    this.onHandleSearch();
    this.setupFilterSubscriptions();
    //primer carga de datos
    this.findAllWithCount();
  }

  getDayNames(days: number[]): string {
    return days
      .map((day) => {
        const foundDay = this.daysList.find((d) => d.value === day);
        return foundDay ? foundDay.day : "";
      })
      .join(", ");
  }

  private initializeCreateMaterial(): ICreateMaterial {
    return {
      code: "",
      externalKeys: {
        code: "",
      },
      name: "",
      descriptionShort: "",
      descriptionLong: "",
      price: 0,
      costPrice: 0,
      UMPActive: false,
      ltsLbs: 0,
      barcodeType: "",
      barcode: "",
      position: 0,
      batchControlActive: false,
      companyId: "",
      distributionChains: [],
      divisionId: "",
      materialGroupId: [],
      baseunitMeasurementId: "",
      alternalUnitOfMeasures: [],
      classifications: "",
      distributionunitMeasurementId: "",
      canMakeAnOrderWithoutStock: null,
    };
  }

  private initializeCreateUnit(): ICreateUnitMeasure {
    return {
      quantity: 0,
      equivalentQuantity: 0,
      unitMeasureId: "",
      conversionFactor: 0,
      isUMB: false,
      isUMP: false,
    };
  }

  private initializeCreateDimension(): ICreateDimension {
    return {
      height: 0,
      width: 0,
      length: 0,
      grossWeight: 0,
      netWeight: 0,
      weightUnitOfMeasureCode: "",
      volume: 0,
      volumeUnitOfMeasureCode: "",
    };
  }

  private initializeCreateTax(): ICreateTax {
    return {
      name: "",
      percentage: 0,
    };
  }

  // ...
  private initializeCreateOrder(): ICreateOrder {
    return {
      _id: "",
      days: [],
      hourStart: "",
      hourEnd: "",
      minutesStart: 0,
      minutesEnd: 0,
      numberOfHoursToDelivery: 0,
    };
  }

  // ...

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onPageChangeUnit(event: PageEvent): void {
    this.pageSizeUnit = event.pageSize;
    this.pageIndexUnit = event.pageIndex + 1;
    this.unitService
      .findByMaterialId(this.currentUpdateMaterial._id.toString())
      .subscribe((data) => {
        this.currentUpdateMaterial.alternalUnitOfMeasures = data?.data;
        this.paginator.length = this.totalItemsUnit;
      });
  }

  toggleAddUnitForm(): void {
    this.showAddUnitForm = !this.showAddUnitForm;
    if (this.showAddUnitForm) {
      this.currentCreateUnit = this.initializeCreateUnit();
      this.currentUpdateUnit = undefined;
    }
  }

  toggleAddOrderForm(): void {
    this.showAddOrderForm = !this.showAddOrderForm;
    if (this.showAddOrderForm) {
      this.currentDelivery = this.initializeCreateOrder();
      // this.currentUpdateUnit = undefined;
    }
  }

  private async fetchCompanies(): Promise<void> {
    const res = await firstValueFrom(this.companyService.findToComboBox());
    this.companyList = res.data;
    this.companiesLoaded = true;
    this.ERPActive = false;
    this.numberOfDecimals = this.companyList[0].numberOfDecimals;
  }

  private async fetchDivisions(): Promise<void> {
    const res = await firstValueFrom(this.divisionService.findToComboBox());
    this.divisionList = res.data;
    this.divisionsLoaded = true;
  }

  private async fetchAllRequirement(): Promise<void> {
    try {
      const res = await firstValueFrom(
        this.requirementService.findToComboBox()
      );
      this.requirementList = res.data;
    } catch (err) {
      this.snackBar.open(
        err.error?.message || "Error al obtener requerimientos.",
        "Cerrar",
        { duration: 5000 }
      );
    }
  }

  private async fetchAllMaterialGroups(): Promise<void> {
    const paginationOptions = {
      search: "",
      currentPage: 1,
      limitPerPage: 500, // Término de búsqueda que el usuario ingresó
    };
    const res = await firstValueFrom(
      this.materialGroupService.findToComboBox(paginationOptions)
    );
    this.materialGroupList = res.data[0].data;
    this.materialGroupsLoaded = true;
  }

  //   private fetchMaterialGroups(): void {
  //     const paginationOptions = {
  //     search: '',  // Inicialmente, con término de búsqueda vacío
  //     };
  //     this.materialGroupService.findToComboBox(paginationOptions).subscribe({
  //       next: (res) => {
  //       this.materialGroupList = res.data;
  //       this.filteredGroup.next(this.materialGroupList);

  //       this.filteredGroup.pipe(take(1)).subscribe((materials) => {
  //         const selectedMaterials = materials.filter((aterial) =>
  //           this.currentUpdateMaterial?.materialGroups
  //             .map((r) => r._id.toString())
  //             .includes(material._id.toString())
  //         );
  //         this.groupMultiCtrl.setValue(selectedMaterials);
  //       });

  //       // listen for search field value changes
  //       this.groupMultiFilterCtrl.valueChanges
  //         .pipe(takeUntil(this._onDestroy))
  //         .subscribe(() => {
  //           this.filterMultiGroup();
  //           this.setToggleAllCheckboxStateGroup();
  //         });

  //     },
  //     error: (err) => {
  //     },
  //   });
  // }

  private fetchMaterialGroups(): void {
    const paginationOptions = {
      search: "",
      currentPage: 1,
      limitPerPage: 300,
    };

    this.materialGroupService.findToComboBox(paginationOptions).subscribe({
      next: (res) => {
        this.materialGroupList = res.data[0].data;
        // const group = this.getGroupedData(this.materialGroupList);
        this.filteredGroup.next(this.materialGroupList);

        this.filteredGroup.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentUpdateMaterial?.materialGroups
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.groupMultiCtrl.setValue(selectedMaterials);
        });
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener grupos de materiales.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });

    // Escuchar cambios en el campo de búsqueda
    this.groupMultiFilterCtrl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        switchMap((searchTerm) => {
          const paginationOptions = {
            search: searchTerm,
            currentPage: 1,
            limitPerPage: 50,
          };
          return this.materialGroupService.findToComboBox(paginationOptions);
        }),
        takeUntil(this._onDestroy)
      )
      .subscribe({
        next: (res) => {
          if (!this.isInitialized) return;
          this.filterMultiGroup();
          this.setToggleAllCheckboxStateGroup();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener grupo de materiales.",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  fetchCategories(): void {
    this.materialGroupService
      .fetchCategories(
        environment.companyId,
        [],
        null //item group
      )
      .subscribe({
        next: (res) => {
          if (res.status == "success") {
            this.materialGroupList = res.data;
            this.materialGroupFilterList = res.data.slice();

            if (this.isProjectTree) {
              let tempTree = [];
              this.getTree(this.categoryPrincipal, "0");
              tempTree.push(this.categoryPrincipal);
              this.listCategories = tempTree[0].children;
            } else {
              this.listCategories = this.materialGroupFilterList.slice();
            }
          }
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener categorias.",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  getTree(data, fatherCode) {
    data.children = this.materialGroupFilterList.filter(
      (res) => res.fatherCode == fatherCode
    );
    for (let item of data.children) {
      if (item.hasSubcategories) {
        item.children = [];
        this.getTree(item, item.code);
      }
    }
  }

  public filterTree(filterText: string): void {
    let filteredTreeData = [];
    let adicional = [];

    if (filterText) {
      filteredTreeData = this.materialGroupFilterList.filter(
        (d) =>
          d.name.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) >
          -1
      );
      for (let item of filteredTreeData) {
        let fatherCode = item.fatherCode;
        while (fatherCode != "0") {
          let padre = this.materialGroupFilterList.find(
            (res) => res.code == fatherCode
          );
          fatherCode = padre.fatherCode;
          if (!adicional.find((res) => res.code == item.code)) {
            let aux2 = padre;
            delete aux2.children;
            adicional.push(aux2);
          }
        }
      }

      for (let item of adicional) {
        filteredTreeData.push(item);
      }

      var unique = filteredTreeData.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });
      filteredTreeData = unique;
    } else {
      filteredTreeData = this.materialGroupFilterList;
    }

    let categoryPrincipalF = {
      name: "Principal",
      code: "0",
      fatherCode: "0",
      hasSubcategories: true,
      level: 0,
      expandable: true,
      children: [],
    };

    this.listFilterCategories = filteredTreeData;
    let categoryNodeFilter = [];
    this.getTreeFilter(categoryPrincipalF, "0");
    categoryNodeFilter.push(categoryPrincipalF);
    this.listCategories = categoryNodeFilter[0].children; //el primero es estatico
  }

  getTreeFilter(data, fatherCode) {
    data.children = this.listFilterCategories.filter(
      (res) => res.fatherCode == fatherCode
    );
    for (let item of data.children) {
      if (item.hasSubcategories) {
        item.children = [];
        this.getTreeFilter(item, item.code);
      }
    }
  }

  changueOptionsGroupMaterial(event) {
    if (!this.materialGroupFilterList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listCategories = this.materialGroupFilterList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listCategories = this.materialGroupFilterList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  protected filterMultiGroup() {
    if (!this.materialGroupList) {
      return;
    }
    // get the search keyword
    let search = this.groupMultiFilterCtrl.value;
    if (!search) {
      this.filteredGroupCache = this.materialGroupList;
      this.filteredGroup.next(this.materialGroupList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredGroupCache = this.materialGroupList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredGroup.next(this.filteredGroupCache);
  }

  protected setToggleAllCheckboxStateGroup() {
    let filteredLength = 0;
    if (this.groupMultiCtrl && this.groupMultiCtrl.value) {
      this.filteredGroupCache.forEach((el) => {
        if (this.groupMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateGroup =
        filteredLength > 0 && filteredLength < this.filteredGroupCache.length;
      this.isCheckedGroup =
        filteredLength > 0 && filteredLength === this.filteredGroupCache.length;
    }
  }

  private async fetchMaterialBrands(): Promise<void> {
    const res = await firstValueFrom(
      this.materialBrandService.findToComboBox()
    );
    this.materialBrandList = res.data;
    this.materialBrandsLoaded = true;
  }

  private async fetchMaterialType(): Promise<void> {
    const res = await firstValueFrom(this.materialTypeService.findToComboBox());
    this.materialTypeList = res.data;
  }

  private async fetchunitBaseOfMeasurement(): Promise<void> {
    const res = await firstValueFrom(this.baseunitService.findToComboBox());
    this.baseUnitOfMeasuresList = res.data;
    this.baseUnitsLoaded = true;
  }

  getGroupedData(groups: any[]): any[] {
    const groupsMap = new Map<string, any>();

    // Crear los grupos padres
    groups.forEach((group) => {
      if (!group.fatherCode) {
        groupsMap.set(group.code, { ...group, children: [] });
      }
    });

    // Asignar los subgrupos a sus grupos padres
    groups.forEach((group) => {
      if (group.fatherCode) {
        const parentGroup = groupsMap.get(group.fatherCode);
        if (parentGroup) {
          parentGroup.children?.push(group);
        }
      }
    });

    // Devolver los grupos con subgrupos incluidos
    return Array.from(groupsMap.values());
  }

  addRelatedMaterial() {
    const newRelatedMaterialId = (this.currentUpdateMaterial as any)
      .relatedMaterialIds;
    const isDuplicate = this.dataSourceItem.data.some(
      (material) => material._id === newRelatedMaterialId._id.toString()
    );
    if (!isDuplicate) {
      let auxData = this.dataSourceItem.data.slice();
      auxData.push(newRelatedMaterialId);
      this.dataSourceItem.data = auxData;
      this.filtereddataSourceItem.data = this.dataSourceItem.data;
      (this.currentUpdateMaterial as any).relatedMaterialIds = null;
    } else {
      this.snackBar.open("El material ya está agregado", "Cerrar", {
        duration: 3000,
      });
    }
  }
  deleteItem(i: number): void {
    const itemToDelete = this.dataSourceItem.data[i];
    this.dataSourceItem.data = this.dataSourceItem.data.filter(
      (_, index) => index !== i
    );
    this.filtereddataSourceItem.data = this.filtereddataSourceItem.data.filter(
      (item) => item._id !== itemToDelete._id
    );
    this.cdr.detectChanges();
  }

  fetchAllRelatedMaterial(): void {
    // Llamada inicial con término vacío
    const paginationOptions = {
      search: " ",
      currentPage: 1,
      limitPerPage: 500, // Término de búsqueda que el usuario ingresó
    };

    // Realizamos la primera llamada al servidor para cargar los primeros 500 materiales
    this.materialService.findToComboBox(paginationOptions).subscribe({
      next: (res) => {
        this.materialRelatedList = res.data[0].data;
        this.filteredMaterials.next(this.materialRelatedList);

        // Si hay materiales previamente seleccionados, los restauramos
        if (this.currentUpdateMaterial?.relatedMaterialIds) {
          const selectedMaterials = this.materialRelatedList.filter(
            (material) =>
              this.currentUpdateMaterial.relatedMaterialIds.includes(
                material._id.toString()
              )
          );
          this.materialMultiCtrl.setValue(selectedMaterials);
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener materiales relacionados.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });

    this.materialMultiFilterCtrl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        switchMap((searchTerm) => {
          const paginationOptions = {
            search: searchTerm,
            currentPage: 1,
            limitPerPage: 500,
          };
          return this.materialService.findToComboBox(paginationOptions);
        }),
        takeUntil(this._onDestroy)
      )
      .subscribe({
        next: (res) => {
          if (!this.isInitialized) return;
          this.filterBanksMulti();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener materiales.",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  private getRelatedMaterial(): void {
    const materialOptions = {
      search: this.searchText,
      currentPage: 1,
      limitPerPage: 50,
    };

    this.materialService.findToComboBox(materialOptions).subscribe({
      next: (res: IPaginationResult<MaterialAttributes>) => {
        const allMaterials = res.data[0].data ?? [];

        this.materialRelatedList = allMaterials.filter(
          (material) => material.code !== this.currentUpdateMaterial?.code
        );
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener materiales relacionados.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  // private fetchAllRelatedMaterial(): void {
  //   this.materialService.findToComboBox().subscribe({
  //     next: (res) => {
  //       this.materialRelatedList = res.data;

  //       this.filteredMaterials.next(res.data.slice(0,500));

  //       if(this.currentUpdateMaterial?.relatedMaterialIds){
  //       this.filteredMaterials.pipe(take(1)).subscribe((materials) => {
  //         const selectedMaterials = materials.filter((material) =>
  //           this.currentUpdateMaterial?.relatedMaterialIds.includes(
  //             material._id.toString()
  //           )
  //         );
  //         this.materialMultiCtrl.setValue(selectedMaterials);
  //       });
  //     }
  //            // listen for search field value changes
  //      this.materialMultiFilterCtrl.valueChanges
  //      .pipe(
  //       debounceTime(150),
  //       takeUntil(this._onDestroy))
  //      .subscribe(() => {
  //        this.filterBanksMulti();
  //        // this.setToggleAllCheckboxState();
  //      });

  //  },
  //     error: (err) => {
  //     },
  //   });
  // }

  changueOptionsMaterial(event) {
    this.searchSubject.next(event);
  }

  private setupMaterialSearchControl(): void {
    this.searchSubject
      .pipe(skip(1), debounceTime(500), distinctUntilChanged())
      .subscribe((searchTerm) => {
        if (!this.isInitialized) return;
        if (searchTerm) {
          this.searchText = searchTerm;
          this.getRelatedMaterial();
        }
      });
  }

  toggleSelectAllGroup(selectAllValue: boolean) {
    this.filteredGroup
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.groupMultiCtrl.patchValue(val);
        } else {
          this.groupMultiCtrl.patchValue([]);
        }
      });
  }

  protected filterBanksMulti() {
    if (!this.materialRelatedList) {
      return;
    }
    // get the search keyword
    let search = this.materialMultiFilterCtrl.value;
    if (!search) {
      this.filteredMaterialCache = this.materialRelatedList;
      this.filteredMaterials.next(this.materialRelatedList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the material
    this.filteredMaterialCache = this.materialRelatedList.filter(
      (material) => material.name.toLowerCase().indexOf(search) > -1
    );
    this.filteredMaterials.next(this.filteredMaterialCache.slice(0, 500));
  }

  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.materialMultiCtrl && this.materialMultiCtrl.value) {
      this.filteredMaterialCache.forEach((el) => {
        if (this.materialMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 &&
        filteredLength < this.filteredMaterialCache.length;
      this.isChecked =
        filteredLength > 0 &&
        filteredLength === this.filteredMaterialCache.length;
    }
  }

  private async getAllMaterialList(): Promise<void> {
    try {
      const res = await firstValueFrom(
        this.materialListService.findToComboBox()
      );
      this.materialListList = res.data ?? [];
      this.listFilterMaterialList = this.materialListList.slice();
    } catch (err) {
      this.snackBar.open(
        err.error?.message || "Error al obtener materiales.",
        "Cerrar",
        { duration: 5000 }
      );
    }
  }

  changueOptionsMaterialList(event) {
    if (!this.materialListList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterMaterialList = this.materialListList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterMaterialList = this.materialListList.filter(
      (item) => item.name.toLowerCase().indexOf(search) > -1
    );
  }

  findAllWithCount(): void {
    const hasSearch = this.searchQuery && this.searchQuery.trim().length > 0;
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction
      ? this.sort.direction === "asc"
        ? "ASC"
        : "DESC"
      : "ASC";

    const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);
    const divisionCodes = this.getSelectedDivisionCodes(
      this.selectedDivisionIds
    );
    const materialGroupCodes = this.getSelectedMaterialGroupCodes(
      this.selectedMaterialGroupIds
    );
    const materialBrandCodes = this.getSelectedMaterialBrandCodes(
      this.selectedMaterialBrandIds
    );
    const baseUnitofMeasureCodes = this.getSelectedBaseUnitOfMeasures(
      this.selectedBaseUnitOfMeasuresIds
    );

    let filter: IFilters = {
      companyId: this.form.get("companyId")?.value,
      divisionId: this.form.get("divisionId")?.value,
      materialBrandId: this.form.get("materialBrandId")?.value,
      materialGroupId: this.form.get("materialGroupId")?.value,
      status: this.selectedStatuses.length ? this.selectedStatuses : null,
    };
    this.materialService
      .findAllWithCount(
        {
          currentPage: hasSearch ? 1 : this.pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        },
        filter
        // companyCodes,
        // divisionCodes,
        // materialBrandCodes,
        // materialGroupCodes,
        // baseUnitofMeasureCodes
      )
      .subscribe((data) => {
        data?.data?.[0]?.data.forEach((material) => {
          if (material.canMakeAnOrderWithoutStock === null) {
            material.canMakeAnOrderWithoutStock = "NULL" as any;
          }
        });

        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof MaterialAttributes {
    const validSortFields: (keyof MaterialAttributes)[] = [
      "code",
      "name",
      "price",
      "position",
    ];
    return validSortFields.includes(
      this.sort.active as keyof MaterialAttributes
    )
      ? (this.sort.active as keyof MaterialAttributes)
      : "position";
  }

  //sort
  onListDrop(event: CdkDragDrop<any[]>) {
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
    this.dataSource = clonedeep(this.dataSource);
  }

  setPosition(event) {
    // Swap the elements around
    this.loadSetPosition = true;

    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
    // updates moved data and table, but not dynamic if more dropzones
    this.dataSource = clonedeep(this.dataSource);
    this.loadSetPosition = false;
  }

  onsaveChangesOrder() {
    let aux: any[] = [];
    this.dataSource.forEach((element) => {
      aux.push(element._id);
    });

    let data = {
      ids: aux,
    };

    this.materialService.sortGlobal(data).subscribe({
      next: () => {
        this.findAllWithCount();
        this.isEditSort = false;
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  openDistributionChainModal(existingData?: any) {
    const dialogRef = this.dialog.open(MaterialDistributionChainComponent, {
      panelClass: "form-modal",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateMaterialChain(result);
        } else {
          this.createMaterialChain(result);
        }
      }
    });
  }

  createMaterialChain(result): void {
    this.materialDistributionService
      .createEmbedded(this.currentUpdateMaterial._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.materialDistributionService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.distributionChains = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }
  updateMaterialChain(result): void {
    this.materialDistributionService
      .updateEmbedded(
        this.currentUpdateMaterial._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.materialDistributionService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.distributionChains = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  onStatusChangeChain(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerChain = { ...item, statusId: updatedStatusId };

    this.materialDistributionService
      .updateEmbedded(
        this.currentUpdateMaterial._id.toString(),
        item._id.toString(),
        updatedBusinessPartnerChain
      )
      .subscribe({
        next: () => {
          this.materialDistributionService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.distributionChains = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.materialDistributionService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.distributionChains = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }

  openDeleteChain(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteMaterialChain(item));
  }

  deleteMaterialChain(item: any): void {
    this.materialDistributionService
      .deleteEmbedded(
        this.currentUpdateMaterial._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.snackBar.open(
          "Cadena de distribución eliminada con éxito",
          "Cerrar",
          {
            duration: 3000,
          }
        );
        this.materialDistributionService
          .findByMaterialId(this.currentUpdateMaterial._id.toString())
          .subscribe((data) => {
            this.currentUpdateMaterial.distributionChains = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }

  async openCreateModal(): Promise<void> {
    // Esperar a que todos los datos necesarios estén cargados
    await this.ensureCreateModalDataLoadedAsync();
    this.currentUpdateMaterial = null;
    this.currentCreateMaterial = this.initializeCreateMaterial();
    this.dialog
      .open(this.addModal, { panelClass: "form-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.createMaterial();
        }
      });
  }

  createMaterial(): void {
    /* this.currentCreateMaterial.materialGroupId = this.groupMultiCtrl.value.map(
      (ware: MaterialGroupAttributes) => ware._id.toString()
    ); */
    this.currentCreateMaterial.canMakeAnOrderWithoutStock =
      this.currentCreateMaterial.canMakeAnOrderWithoutStock === "NULL"
        ? null
        : this.currentCreateMaterial.canMakeAnOrderWithoutStock;

    // Asegurar que externalKeys existe antes de asignar el código
    if (!this.currentCreateMaterial.externalKeys) {
      this.currentCreateMaterial.externalKeys = {};
    }
    this.currentCreateMaterial.externalKeys.code =
      this.currentCreateMaterial.code;

    this.materialService.create(this.currentCreateMaterial).subscribe({
      next: (result) => {
        let unitBase = {
          _id: "",
          quantity: 1,
          equivalentQuantity: 1,
          unitMeasureId: result.data.baseUnitOfMeasure._id.toString(),
          conversionFactor: 1,
          isUMB: true,
          isUMP: false,
        };
        this.unitService
          .createEmbedded(result.data._id.toString(), unitBase)
          .subscribe({
            next: () => {},
          });
        this.snackBar.open("Material creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el material",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  createTax(): void {
    this.taxService
      .createEmbedded(
        this.currentUpdateMaterial._id.toString(),
        this.currentCreateTax
      )
      .subscribe({
        next: (result) => {
          this.snackBar.open("Impuesto creada con éxito", "Cerrar", {
            duration: 3000,
          });
          this.taxService
            .findByMaterialId(
              this.currentUpdateMaterial._id.toString(),
              result.data._id.toString()
            )
            .subscribe((data) => {
              this.currentUpdateMaterial.tax = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el unidad",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  createDimension(): void {
    this.dimensionService
      .createEmbedded(
        this.currentUpdateMaterial._id.toString(),
        this.currentCreateDimension
      )
      .subscribe({
        next: (result) => {
          this.snackBar.open("Dimensiones creadas con éxito", "Cerrar", {
            duration: 3000,
          });
          this.dimensionService
            .findByMaterialId(
              this.currentUpdateMaterial._id.toString(),
              result.data._id.toString()
            )
            .subscribe((data) => {
              this.currentUpdateMaterial.dimensions = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear las dimensiones",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  createOrder(result): void {
    this.orderService
      .createEmbedded(this.currentUpdateMaterial._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Orden creada con éxito", "Cerrar", {
            duration: 3000,
          });
          this.showAddOrderForm = false;
          this.orderService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.orderDeliveryWindows = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear la orden",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  loadFieldsMasterData(company): void {
        this.companyFieldCatalogService.getFieldsMaster(company._id.toString(), UserFieldEntityTypeEnum.MATERIAL)
        .pipe(take(1))
        .subscribe({
          next: (res) => {
            this.fieldsMasterDataStatus = res.data.statusId;
            this.fieldsMasterData = res.data.fields;
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error fetching fields master data",
              "Cerrar",
              { duration: 5000 }
            );
          },
        });
      }

  async openEditModal(material: MaterialAttributes): Promise<void> {
    // Esperar a que todos los datos necesarios estén cargados
    await this.ensureEditModalDataLoadedAsync();
    this.setupMaterialSearchControl();
    this.getRelatedMaterial();

    const selectedCompany = this.companyList.find(
      (company) => company._id === material.company._id
    );

    this.distributionUnitOfMeasureList = this.baseUnitOfMeasuresList.filter(
      (unit) =>
        material.alternalUnitOfMeasures?.some((unitAlt) => {
          if (!selectedCompany?.UMPActive) {
            if (unitAlt.unitOfMeasure.code === unit.code && unitAlt.isUMB) {
              return unit;
            }
          } else {
            if (unitAlt.unitOfMeasure.code === unit.code) {
              return unit;
            }
          }

          return null;
        })
    );

    const selectedDivision = this.divisionList.find(
      (division) => division._id === material.division._id
    );

    const selectedBrand =
      this.materialBrandList.find(
        (materialBrand) => materialBrand?._id === material?.materialBrand?._id
      ) || null;

    const selectedType =
      this.materialTypeList.find(
        (materialType) => materialType?._id === material?.type?._id
      ) || null;

    /* const selectedGroup = this.materialGroupList.find((materialGroup) =>
      material.materialGroups.some((group) => group._id === materialGroup._id)
    ) || null; */
    const selectedGroup = material?.materialGroups.map((item: any) => item._id);
    const requirement = material?.requirements?.map((item: any) => item._id);
    const tax = material.tax || { name: "", percentage: null };
    const dimension = material.dimensions || this.initializeCreateDimension();

    this.currentUpdateMaterial = {
      ...material,
      company: selectedCompany || material.company,
      division: selectedDivision || material.division,
      materialBrand: selectedBrand || material.materialBrand,
      type: selectedType || material.type,
      requirements: requirement || material.requirements,
      //materialGroups: selectedGroup ? [...material.materialGroups, selectedGroup]: material.materialGroups,
      materialGroups: selectedGroup,
      tax: tax,
      dimensions: dimension,
      materialListId: material.materialList ? material.materialList._id : null,
      distributionUnitOfMeasure: material.distributionUnitOfMeasure,
      acceptChange: material.acceptChange || false,
      acceptReturn: material.acceptReturn || false,
      canMakeAnOrderWithoutStock:
        material.canMakeAnOrderWithoutStock == null
          ? "NULL"
          : material.canMakeAnOrderWithoutStock,
    } as any;

    const currentWarehouses = material?.warehouses ?? [];
    this.selectedWarehousesEdit = currentWarehouses.map((item) =>
      item._id.toString()
    );
    this.availableInAllWarehousesEdit = material.availableInAllWarehouses;

    this.isEditingDimension = !!(
      this.currentUpdateMaterial.dimensions.height ||
      this.currentUpdateMaterial.dimensions.width ||
      this.currentUpdateMaterial.dimensions.length ||
      this.currentUpdateMaterial.dimensions.grossWeight ||
      this.currentUpdateMaterial.dimensions.netWeight ||
      this.currentUpdateMaterial.dimensions.weightUnitOfMeasureCode ||
      this.currentUpdateMaterial.dimensions.volume ||
      this.currentUpdateMaterial.dimensions.volumeUnitOfMeasureCode
    );

    this.isEditingTax = !!(
      this.currentUpdateMaterial.tax.name ||
      this.currentUpdateMaterial.tax.percentage
    );

    this.currentCreateTax = {
      ...this.currentUpdateMaterial.tax,
      ...(this.isEditingTax ? {} : { name: "", percentage: 0 }),
    };

    this.currentCreateDimension = {
      ...this.currentUpdateMaterial.dimensions,
      ...(this.isEditingDimension ? {} : this.initializeCreateDimension()),
    };
    this.dataSourceItem.data = [];
    this.filtereddataSourceItem.data = [];
    if (
      this.currentUpdateMaterial.relatedMaterialIds &&
      this.currentUpdateMaterial.relatedMaterialIds.length > 0
    ) {
      this.materialService
        .findToRelated(this.currentUpdateMaterial.relatedMaterialIds)
        .subscribe((res) => {
          this.dataSourceItem.data = res.data;
          this.filtereddataSourceItem.data = res.data;
        });
    }

    let mappedSubApplications = [];
    if (material?.subApplications) {
      mappedSubApplications = material.subApplications
        .map((subId: ShortSubApplicationsAttributes) => subId._id)
        .filter((item) => item !== null);
    }

    this.subMultiCtrl.setValue(mappedSubApplications);

    // Inicializar datos de warehouses para edición
    this.selectedWarehousesEdit =
      material.warehouses?.map((w) => w._id.toString()) || [];
    this.availableInAllWarehousesEdit =
      material.availableInAllWarehouses || false;
    this.isWarehouseEditFormValid = true;

    // this.loadFieldsMasterData(selectedCompany);

    this.dialog
      .open(this.editModal, { panelClass: "form-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.updateMaterial(material._id.toString());
        }
      });
  }

  openEditUnit(unit: AlternalUnitMeasurementAttributes): void {
    this.currentCreateUnit = {
      ...this.initializeCreateUnit(),
      _id: unit._id.toString(),
      unitMeasureId: unit.unitOfMeasure._id.toString(),
      isUMP: unit.isUMP,
      quantity: unit.quantity,
      equivalentQuantity: unit.equivalentQuantity,
      conversionFactor: unit.conversionFactor,
    };
    this.showAddUnitForm = true;
    this.isEditing = true;
  }

  openEditOrder(order: orderDeliveryWindowsAttributes): void {
    this.currentDelivery = {
      ...this.initializeCreateOrder(),
      _id: order._id.toString(),
      days: order.days,
      hourStart: order.hourStart,
      hourEnd: order.hourEnd,
      minutesStart: order.minutesStart,
      minutesEnd: order.minutesEnd,
    };
    this.showAddOrderForm = true;
    this.isOrderEditing = true;
  }

  isBaseUnit(element: any): boolean {
    return (
      element.unitOfMeasure?._id ===
      this.currentUpdateMaterial.baseUnitOfMeasure?._id
    );
  }

  openUnitModal(material: MaterialAttributes): void {
    this.currentUpdateMaterial = {
      ...material,
      alternalUnitOfMeasures: material.alternalUnitOfMeasures.map((uom) => ({
        ...uom,
        baseUnitOfMeasure: material.baseUnitOfMeasure, // Asociar la unidad base
      })),
    };
    this.currentCreateUnit = this.initializeCreateUnit();
    this.dialog
      .open(this.addModalUnit, { panelClass: "form-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          // result.buOfMsave = result.baseUnitOfMeasure?.name || result.buOfMsave
          // this.currentUpdateMaterial.baseUnitOfMeasure = result.buOfMsave;
          // this.currentUpdateMaterial.alternalUnitOfMeasures.push(result);

          this.cdr.detectChanges();
        }
      });
  }

  openAddUnitModal(existingData?) {
    const material = this.currentUpdateMaterial;
    const dialogRef = this.dialog.open(AddMaterialUnit, {
      panelClass: ".form-modal",
      data: {
        existingData: existingData,
        material: material,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateUnit(result);
        } else {
          this.createUnit(result);
        }
        // if (result.buOfMsave) {
        //   this.currentUpdateMaterial.baseUnitOfMeasure = {
        //     ...this.currentUpdateMaterial.baseUnitOfMeasure,
        //     name: result.buOfMsave,
        //   };
        // }
        this.cdr.detectChanges();
      }
    });
  }

  public onBaseMeasurestUnitChange(initBaseMeasure) {
    if (initBaseMeasure) {
      this.currentCreateMaterial.distributionunitMeasurementId =
        initBaseMeasure;
    }
  }

  createUnit(result): void {
    this.unitService
      .createEmbedded(this.currentUpdateMaterial._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Unidad creada con éxito", "Cerrar", {
            duration: 3000,
          });
          this.unitService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.alternalUnitOfMeasures = data?.data;
              this.cdr.detectChanges();
              this.currentUpdateMaterial.alternalUnitOfMeasures.forEach(
                (unit) => {
                  this.isBaseUnit(unit);
                }
              );
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el unidad",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateUnit(result): void {
    this.unitService
      .updateEmbedded(
        this.currentUpdateMaterial._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Unidad actualizado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.unitService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.alternalUnitOfMeasures = data?.data;
              this.cdr.detectChanges();
              this.currentUpdateMaterial.alternalUnitOfMeasures.forEach(
                (unit) => {
                  // Llamar a isBaseUnit para cada unidad y actualizar el estado
                  this.isBaseUnit(unit); // Si es necesario, puedes recalcular cualquier lógica aquí
                }
              );
              this.cdr.detectChanges();
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar la unidad",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  openAddOrderModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerOrderComponent, {
      panelClass: ".form-modal",
      data: existingData,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateOrder(result);
        } else {
          this.createOrder(result);
        }
      }
    });
  }

  openOrderModal(material: MaterialAttributes): void {
    this.currentUpdateMaterial = {
      ...material,
    };
    this.dialog
      .open(this.deliveryModal, {
        panelClass: "form-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {});
  }

  updateMaterial(id: string): void {
    if (this.currentUpdateMaterial) {
      const selectedMaterialIds = this.dataSourceItem.filteredData.map((item) =>
        item._id.toString()
      );
      const updatedMaterial: IUpdateMaterial = {
        externalKeys: {
          code: this.currentUpdateMaterial.code,
        },
        companyId: this.currentUpdateMaterial.company._id.toString(),
        divisionId: this.currentUpdateMaterial.division._id.toString(),
        materialBrandId:
          this.currentUpdateMaterial.materialBrand?._id.toString() || null,
        materialTypeId: this.currentUpdateMaterial.type?._id.toString() || null,
        //materialGroupId: this.groupMultiCtrl.value.map((div: MaterialGroupAttributes) =>div._id.toString()),
        materialGroupId: this.currentUpdateMaterial.materialGroups.map((item) =>
          String(item)
        ),
        requirementId: this.currentUpdateMaterial?.requirements?.map((item) =>
          String(item)
        ),
        ...this.currentUpdateMaterial,
        relatedMaterialIds: selectedMaterialIds,
        materialListId: (this.currentUpdateMaterial as any).materialListId,
        distributionunitMeasurementId:
          this.currentUpdateMaterial?.distributionUnitOfMeasure?._id.toString() ||
          null,
        subAppsIds:
          this.subMultiCtrl?.value?.map((selection: any) => selection) || [],
        canMakeAnOrderWithoutStock:
          String(this.currentUpdateMaterial.canMakeAnOrderWithoutStock) ===
          "NULL"
            ? null
            : this.currentUpdateMaterial.canMakeAnOrderWithoutStock,
        warehouseIds: this.currentUpdateMaterialWarehouseIds,
        availableInAllWarehouses:
          this.currentUpdateMaterial.availableInAllWarehouses || false,
      };
      this.currentUpdateMaterial.relatedMaterialIds = selectedMaterialIds;

      this.materialService.update(id, updatedMaterial).subscribe({
        next: (result) => {
          this.snackBar.open("Material actualizado con éxito", "Cerrar", {
            duration: 3000,
          });

          this.findAllWithCount();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el material",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  updateOrder(result: any): void {
    this.orderService
      .updateEmbedded(
        this.currentUpdateMaterial._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Unidad actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.showAddOrderForm = false;
          this.orderService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.orderDeliveryWindows = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar la orden",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateTax(id: string): void {
    if (this.currentCreateTax) {
      const updateTax: ICreateTax = {
        ...this.currentCreateTax,
      };
      this.taxService
        .updateEmbedded(
          this.currentUpdateMaterial._id.toString(),
          id,
          updateTax
        )
        .subscribe({
          next: () => {
            this.snackBar.open("Unidad actualizado con éxito", "Cerrar", {
              duration: 3000,
            });
            this.taxService
              .findByMaterialId(this.currentUpdateMaterial._id.toString(), id)
              .subscribe((data) => {
                this.currentUpdateMaterial.tax = data.data;
                this.paginator.length = this.totalItems;
              });
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error al actualizar el unidad",
              "Cerrar",
              { duration: 3000 }
            );
          },
        });
    }
  }

  updateDimension(id: string): void {
    if (this.currentCreateDimension) {
      const updateDimension: ICreateDimension = {
        ...this.currentCreateDimension,
      };
      this.dimensionService
        .updateEmbedded(
          this.currentUpdateMaterial._id.toString(),
          id,
          updateDimension
        )
        .subscribe({
          next: () => {
            this.snackBar.open("Unidad actualizado con éxito", "Cerrar", {
              duration: 3000,
            });
            this.dimensionService
              .findByMaterialId(this.currentUpdateMaterial._id.toString(), id)
              .subscribe((data) => {
                this.currentUpdateMaterial.dimensions = data.data;
                this.paginator.length = this.totalItems;
              });
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error al actualizar las dimensiones",
              "Cerrar",
              { duration: 3000 }
            );
          },
        });
    }
  }

  onStatusOrderChange(
    event: boolean,
    order: orderDeliveryWindowsAttributes
  ): void {
    const originalStatusId = order.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedFrequency: any = {
      ...order,
      statusId: updatedStatusId,
    };
    this.orderService.updateEmbedded(
      this.currentUpdateMaterial._id.toString(),
      order._id.toString(),
      updatedFrequency
    );
    this.orderService
      .updateEmbedded(
        this.currentUpdateMaterial._id.toString(),
        order._id.toString(),
        updatedFrequency
      )
      .subscribe({
        next: () => {
          this.orderService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.orderDeliveryWindows = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          order.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.orderService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.orderDeliveryWindows = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }
  onStatusChange(event: boolean, material: MaterialAttributes): void {
    const originalStatusId = material.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedMaterial = { statusId: updatedStatusId };

    this.materialService
      .update(material._id.toString(), updatedMaterial)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          material.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  onInventoryChange(
    event: MatSelectChange,
    material: MaterialAttributes
  ): void {
    const originalStatusId = material.canMakeAnOrderWithoutStock;
    const updatedStatusId = event.value == "NULL" ? null : event.value;
    const updatedMaterial: IUpdateMaterial = {
      canMakeAnOrderWithoutStock: updatedStatusId,
    };

    this.materialService
      .update(material._id.toString(), updatedMaterial)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          material.canMakeAnOrderWithoutStock = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  clearSelection(): void {
    (this.currentUpdateMaterial as any).materialListId = null;
  }

  openDeleteDialog(material: MaterialAttributes): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: material,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.delete(material._id.toString()));
  }

  openDeleteUnit(unit: AlternalUnitMeasurementAttributes): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: unit,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteUnit(unit._id.toString()));
  }

  openDeleteOrder(order: orderDeliveryWindowsAttributes): void {
    this.dialog
      .open(this.deleteModalOrder, { data: order, panelClass: "delete-modal" })
      .afterClosed()
      .subscribe((result) => result && this.deleteOrder(order._id.toString()));
  }

  delete(id: string): void {
    this.materialService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Material eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  deleteUnit(id: string): void {
    if (this.currentCreateUnit) {
      const updatedUnit: ICreateUnitMeasure = {
        ...this.currentCreateUnit,
      };
      this.unitService
        .deleteEmbedded(
          this.currentUpdateMaterial._id.toString(),
          id,
          updatedUnit
        )
        .subscribe(() => {
          this.snackBar.open("Material eliminado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.unitService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.alternalUnitOfMeasures = data?.data;
              this.paginator.length = this.totalItems;
              this.cdr.detectChanges();
            });
        });
    }
  }

  deleteOrder(id: string): void {
    if (this.currentDelivery) {
      const updatedOrder: ICreateOrder = {
        ...this.currentDelivery,
      };
      this.orderService
        .deleteEmbedded(
          this.currentUpdateMaterial._id.toString(),
          id,
          updatedOrder
        )
        .subscribe(() => {
          this.snackBar.open("Orden eliminada con éxito", "Cerrar", {
            duration: 3000,
          });
          this.orderService
            .findByMaterialId(this.currentUpdateMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateMaterial.orderDeliveryWindows = data?.data;
              this.paginator.length = this.totalItems;
            });
        });
    }
  }

  openImagesModal(material: MaterialAttributes): void {
    const dialogRef = this.dialog.open(ListImagesComponent, {
      panelClass: ".form-modal-interlocutor",
      data: material,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  getSelectedCompanyCodes(selectedIds: string[]): number[] {
    return selectedIds.map(
      (id) =>
        this.companyList.find((company) => company._id.toString() === id)?.id
    );
  }

  getSelectedDivisionCodes(selectedIds: string[]): number[] {
    return selectedIds.map(
      (id) =>
        this.divisionList.find((division) => division._id.toString() === id)?.id
    );
  }

  getSelectedMaterialGroupCodes(selectedIds: string[]): string[] {
    return selectedIds.map(
      (id) =>
        this.materialGroupList.find((group) => group._id.toString() === id)
          ?.code
    );
  }

  getSelectedMaterialBrandCodes(selectedIds: string[]): string[] {
    return selectedIds.map(
      (id) =>
        this.materialBrandList.find((brand) => brand._id.toString() === id)
          ?.code
    );
  }

  getSelectedBaseUnitOfMeasures(selectedIds: string[]): string[] {
    return selectedIds.map((id) =>
      this.baseUnitOfMeasuresList
        .find((brand) => brand._id.toString() === id)
        ?._id.toString()
    );
  }

  /*onSearchChange = debounce((event: Event) => {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();

    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }, 500);*/

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .pipe(skip(1), debounceTime(300), distinctUntilChanged())
      .subscribe((term) => {
        if (!this.isInitialized) return;
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.findAllWithCount();
        }
      });
  }

  private setupFilterSubscriptions(): void {
    // Filtros del formulario
    const filterControls = [
      "companyId",
      "divisionId",
      "materialGroupId",
      "materialBrandId",
    ];

    filterControls.forEach((controlName) => {
      this.form
        .get(controlName)
        ?.valueChanges.pipe(
          skip(1),
          debounceTime(500),
          distinctUntilChanged(),
          takeUntil(this._onDestroy)
        )
        .subscribe(() => {
          if (!this.isInitialized) return;
          this.pageIndex = 1;
          this.findAllWithCount();
        });
    });
  }

  searchInDataSourceItem(event: Event): void {
    const input = event.target as HTMLInputElement;
    let searchTerm = input.value.trim().toLowerCase();
    if (!searchTerm) {
      this.dataSourceItem.data = this.filtereddataSourceItem.data;
    } else {
      this.dataSourceItem.data = this.filtereddataSourceItem.data.filter(
        (item) =>
          item.name.toLowerCase().includes(searchTerm) ||
          item.code.toLowerCase().includes(searchTerm)
      );
    }
  }

  // Método que se activa cuando se selecciona una nueva Compañía
  onCompanySelectionChange(companyId: string): void {
    const selectedCompany = this.companyList.find(
      (company) => company._id.toString() === companyId
    );
    if (this.currentUpdateMaterial && selectedCompany) {
      this.currentUpdateMaterial.company = selectedCompany;
    }
  }

  onDivisionSelectionChange(divisionId: string): void {
    if (this.currentUpdateMaterial) {
      this.currentUpdateMaterial.division = this.divisionList.find(
        (division) => division._id.toString() === divisionId
      )!;
    }
  }

  onMaterialBrandSelectionChange(materialBrandId: string): void {
    if (this.currentUpdateMaterial) {
      this.currentUpdateMaterial.materialBrand = this.materialBrandList.find(
        (brand) => brand._id.toString() === materialBrandId
      )!;
    }
  }

  onMaterialTypeSelectionChange(materialTypeId: string): void {
    if (this.currentUpdateMaterial) {
      this.currentUpdateMaterial.type = this.materialTypeList.find(
        (brand) => brand._id.toString() === materialTypeId
      )!;
    }
  }

  onMaterialGroupSelectionChange(materialGroupIds: string[]): void {
    if (this.currentUpdateMaterial) {
      this.currentUpdateMaterial.materialGroups = materialGroupIds.map(
        (groupId) =>
          this.materialGroupList.find(
            (group) => group._id.toString() === groupId
          )!
      );
    }
  }

  onMaterialRelatedSelectionChange(relatedMaterialIds: string[]): void {
    if (this.currentUpdateMaterial) {
      this.currentUpdateMaterial.relatedMaterialIds = relatedMaterialIds;
    }
  }

  onUnitMeasureSelectionChange(unitMeasureId: string): void {
    if (this.currentUpdateMaterial) {
      this.currentUpdateMaterial.baseUnitOfMeasure =
        this.baseUnitOfMeasuresList.find(
          (unit) => unit._id.toString() === unitMeasureId
        )!;
    }
  }

  onUnitDisributionSelectionChange(unitDisributionId: string): void {
    if (this.currentUpdateMaterial) {
      this.currentUpdateMaterial.distributionUnitOfMeasure =
        this.baseUnitOfMeasuresList.find(
          (unit) => unit._id.toString() === unitDisributionId
        )!;
    }
  }

  trackByFn(index: number, item: MaterialAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  // compareMaterialById(item1, item2) {
  //   return item1 && item2 ? item1._id === item2 : item1 === item2;
  // }

  convertTo24HourFormat(time: string): string {
    const [timePart, modifier] = time.split(" ");
    let [hours, minutes] = timePart.split(":");

    if (modifier === "PM" && +hours < 12) {
      hours = String(+hours + 12);
    } else if (modifier === "AM" && +hours === 12) {
      hours = "00";
    }

    return `${hours}:${minutes}`;
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.selectedDivisionIds = [];
    this.selectedMaterialGroupIds = [];
    this.selectedMaterialBrandIds = [];
    this.searchQuery = "";
    this.form.reset({
      companyId: null,
      divisionId: null,
      materialGroupId: null,
      materialBrandId: null,
    });
    this.findAllWithCount();
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchCompanies();
    }
  }

  private async ensureCompaniesLoadedAsync(): Promise<void> {
    if (!this.companiesLoaded) {
      await this.fetchCompanies();
    }
  }

  private ensureDivisionsLoaded(): void {
    if (!this.divisionsLoaded) {
      this.fetchDivisions();
    }
  }

  private async ensureDivisionsLoadedAsync(): Promise<void> {
    if (!this.divisionsLoaded) {
      await this.fetchDivisions();
    }
  }

  private ensureMaterialGroupsLoaded(): void {
    if (!this.materialGroupsLoaded) {
      this.fetchAllMaterialGroups();
    }
  }

  private async ensureMaterialGroupsLoadedAsync(): Promise<void> {
    if (!this.materialGroupsLoaded) {
      await this.fetchAllMaterialGroups();
    }
  }

  private ensureMaterialBrandsLoaded(): void {
    if (!this.materialBrandsLoaded) {
      this.fetchMaterialBrands();
    }
  }

  private async ensureMaterialBrandsLoadedAsync(): Promise<void> {
    if (!this.materialBrandsLoaded) {
      await this.fetchMaterialBrands();
    }
  }

  private ensureBaseUnitsLoaded(): void {
    if (!this.baseUnitsLoaded) {
      this.fetchunitBaseOfMeasurement();
    }
  }

  private async ensureBaseUnitsLoadedAsync(): Promise<void> {
    if (!this.baseUnitsLoaded) {
      await this.fetchunitBaseOfMeasurement();
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
    this.ensureDivisionsLoaded();
    this.ensureMaterialGroupsLoaded();
    this.ensureMaterialBrandsLoaded();
  }

  private ensureCreateModalDataLoaded(): void {
    if (!this.dataLoadedForCreateModal) {
      this.ensureBaseUnitsLoaded();
      this.fetchCategories();
      this.fetchAllRequirement();
      this.fetchMaterialType();
      this.dataLoadedForCreateModal = true;
    }
  }

  private async ensureCreateModalDataLoadedAsync(): Promise<void> {
    if (!this.dataLoadedForCreateModal) {
      // Cargar en paralelo todos los datos necesarios para el modal de creación
      await Promise.all([
        this.ensureCompaniesLoadedAsync(),
        this.ensureDivisionsLoadedAsync(),
        this.ensureBaseUnitsLoadedAsync(),
        this.fetchMaterialType(),
        this.fetchAllRequirement(),
      ]);

      // fetchCategories no es async todavía, lo llamamos por separado
      this.fetchCategories();

      this.dataLoadedForCreateModal = true;
    }
  }

  private ensureEditModalDataLoaded(): void {
    if (!this.dataLoadedForEditModal) {
      this.ensureBaseUnitsLoaded();
      this.fetchMaterialType();
      this.fetchCategories();
      this.fetchAllRequirement();
      this.getAllMaterialList();
      this.getApplications();
      this.dataLoadedForEditModal = true;
    }
  }

  private async ensureEditModalDataLoadedAsync(): Promise<void> {
    if (!this.dataLoadedForEditModal) {
      // Cargar en paralelo todos los datos necesarios para el modal de edición
      await Promise.all([
        this.ensureCompaniesLoadedAsync(),
        this.ensureDivisionsLoadedAsync(),
        this.ensureMaterialBrandsLoadedAsync(),
        this.ensureBaseUnitsLoadedAsync(),
        this.fetchMaterialType(),
        this.fetchAllRequirement(),
        this.getAllMaterialList(),
        this.getApplications(),
      ]);

      // fetchCategories no es async todavía, lo llamamos por separado
      this.fetchCategories();

      this.dataLoadedForEditModal = true;
    }
  }

  //exportar
  onExportButtonPressed() {
    if (!this.materialExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: MATERIAL_EXPORT_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.materialExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          Math.max(this.pageIndex, 1)
        );
      }
    });
  }

  private async getApplications(): Promise<void> {
    try {
      const res = await firstValueFrom(
        this.ordersCreationService.getApplications()
      );
      this.applicationList = res;
    } catch (err) {
      this.snackBar.open(
        err.error?.message || "Error al obtener aplicaciones.",
        "Cerrar",
        { duration: 5000 }
      );
    }
  }

  compareFn = (option: any, value: any): boolean => {
    //para subapps
    return (
      option?.parentId === value?.parentId && option?.subId === value?.subId
    );
  };

  onWarehousesChange(data: IWarehouseAssignmentData): void {
    this.currentCreateMaterial.warehouseIds = data.warehouseIds;
    this.currentCreateMaterial.availableInAllWarehouses =
      data.availableInAllWarehouses;
  }

  onWarehouseValidityChange(isValid: boolean): void {
    this.isWarehouseFormValid = isValid;
  }

  onWarehousesEditChange(data: IWarehouseAssignmentData): void {
    if (this.currentUpdateMaterial) {
      this.currentUpdateMaterialWarehouseIds = data.warehouseIds;
      this.currentUpdateMaterial.availableInAllWarehouses =
        data.availableInAllWarehouses;
    }
  }

  onWarehouseEditValidityChange(isValid: boolean): void {
    this.isWarehouseEditFormValid = isValid;
  }

  openWarehouseManagementModal(material: MaterialAttributes): void {
    const dialogRef = this.dialog.open(MaterialWarehouseManagementComponent, {
      panelClass: "form-modal",
      disableClose: true,
      data: {
        materialId: material._id.toString(),
        materialName: material.name,
        materialCode: material.code || material.externalKeys?.code || "",
        currentWarehouses:
          material.warehouses?.map((w) => w._id.toString()) || [],
        availableInAllWarehouses: material.availableInAllWarehouses || false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Recargar el grid si se guardaron cambios
        this.findAllWithCount();
      }
    });
  }

  getEditDisabledTooltip(editFormValid: boolean): string {
    if (!editFormValid && !this.isWarehouseEditFormValid) {
      return "Complete todos los campos obligatorios";
    } else if (!editFormValid) {
      return "Complete los campos obligatorios del formulario";
    } else if (!this.isWarehouseEditFormValid) {
      return 'Debe seleccionar al menos un almacén o marcar "Disponible en todos los almacenes"';
    }
    return "";
  }

  checkGeneralFormValidity(form: any): boolean {
    if (!form) return false;
    return form.valid && this.isWarehouseFormValid;
  }

  onCreateTabChanged(index: number): void {
    this.selectedCreateTabIndex = index;
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  formatCostPrice(material: any) {
    const value = material.costPrice ?? 0;
    material.costPrice = parseFloat(value.toFixed(this.numberOfDecimals));
  }
}
